module.exports = __webpack_public_path__ + "img/3.71bca290.jpg";